<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 15:22:14
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='readonly'
                       :showReturn='false'
                       :showEdit="hasBtn('edit-system-configuration')"
                       :show_del="hasBtn('delete-system-configuration')"
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <systemParameter :disabled='readonly'
                     @changeReadonly='handleEdit'></systemParameter>
  </div>
</template>

<script>
import {
  getSystemParameterList, detailSystemParameter
  , addSystemParameter, updateSystemParameter, deleteSystemParameter
} from '@/service/api/systemParameter.js'
import systemParameter from './modules/systemParameter'
export default {
  components: {
    systemParameter
  },
  props: {},
  data () {
    return {
      readonly: false,
      tab: null,
      list: {}
    };
  },
  computed: {},
  created () { },
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_system_parameters'
          this.$store.commit('set_page_title', 'label_edit_system_parameters')
        }
        else {
          this.$route.meta.title = 'label_view_system_parameters'
          this.$store.commit('set_page_title', 'label_view_system_parameters')
        }
      }, immediate: true
    }
  },
  mounted () {
    this.readonly = this.$store.state.iconstatus
    this.tab = this.$store.state.tab
  },
  beforeDestroy () {
    this.$store.commit('setTab', '')
  },

  methods: {
    change () {
      this.$store.commit('setTab', this.tab)
    },
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        deleteSystemParameter({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'systemParameter'
            })
          }
        })
      })
    },
  },
};
</script>

<style scoped>
</style>
